import { useState, useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';
import { AnimationInputData } from './useGetLatestAnimations';

const useGetAnimationById = () => {
  const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
  const [animation, setAnimation] = useState<AnimationInputData | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchAnimation = useCallback(
    async (id: number): Promise<AnimationInputData | null> => {
      if (!isReady) return null;
      setIsLoading(true);
      setError('');
      try {
        const result: AnimationInputData = await authFetch(`/animation_inputs/${id}`, {
          method: 'GET',
        });
        setAnimation(result);
        return result;
      } catch (err: unknown) {
        setError(err instanceof Error ? err.message : 'Erreur lors du chargement de l\'animation');
        return null;
      } finally {
        setIsLoading(false);
      }
    },
    [authFetch, isReady]
  );

  return { animation, setAnimation, isLoading, error, fetchAnimation };
};

export default useGetAnimationById;
